<div class="flex flex-col w-[480px] rounded-[2rem] overflow-hidden bg-white dark:bg-slate-900 shadow-2xl">

    <!-- Cabecera Premium (Con o Sin Icono) -->
    <div class="w-full px-8 pt-8 pb-4 flex items-center gap-4 border-b border-slate-50 dark:border-slate-800/50">
        <!-- Burbuja de Icono dinámico y translúcido (Solo si existe) -->
        <div *ngIf="data.icon?.show && data.icon?.name" 
            class="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-all"
            [ngClass]="{
                'bg-amber-50 dark:bg-amber-950/30 text-amber-600': data.icon.color === 'accent' || data.icon.color === 'warning',
                'bg-emerald-50 dark:bg-emerald-950/30 text-emerald-600': data.icon.color === 'success',
                'bg-red-50 dark:bg-red-950/30 text-red-600': data.icon.color === 'warn' || data.icon.color === 'error',
                'bg-blue-50 dark:bg-blue-950/30 text-[#008BFF]': data.icon.color === 'info' || data.icon.color === 'primary'
            }"
            [ngStyle]="isHexColor(data.icon.color) ? { 'background-color': getHexRgba(data.icon.color, 0.1), 'color': data.icon.color } : null">
            <mat-icon class="icon-size-6 text-current" [svgIcon]="data.icon.name"></mat-icon>
        </div>

        <!-- Título -->
        <div class="flex-1 min-w-0">
            <h2 class="text-xl font-extrabold tracking-tight text-slate-800 dark:text-white leading-tight" 
                *ngIf="data.title" 
                [innerHTML]="data.title"></h2>
        </div>

        <!-- Botón de Cerrar (X) Premium -->
        <button (click)="onCloseMenu()" 
            class="flex-shrink-0 w-8 h-8 rounded-full bg-slate-100/80 hover:bg-slate-200/80 dark:bg-slate-800/80 dark:hover:bg-slate-700/80 flex items-center justify-center text-slate-500 hover:text-slate-800 transition-all duration-200">
            <mat-icon class="icon-size-4 text-slate-500">close</mat-icon>
        </button>
    </div>

    <!-- Cuerpo del mensaje -->
    <div class="w-full px-8 py-6">
        <div class="text-slate-500 dark:text-slate-400 text-sm leading-relaxed font-medium" 
            *ngIf="data.message" 
            [innerHTML]="data.message"></div>
    </div>

    <!-- Acciones / Botones Inferiores Estilo Premium -->
    <div class="w-full flex items-center justify-end gap-3 px-8 pb-8 pt-4 mt-auto border-t border-slate-50 dark:border-slate-800/50">
        <!-- Cancelar -->
        <button *ngIf="data.actions.cancel.show"
            [matDialogClose]="'cancelled'"
            class="flex items-center justify-center !bg-white !text-slate-700 !border !border-slate-200 rounded-2xl px-6 h-11 text-[11px] font-black tracking-wider uppercase hover:!bg-slate-50 hover:shadow-md transition-all shadow-sm">
            {{ data.actions.cancel.label }}
        </button>

        <!-- Confirmar -->
        <button *ngIf="data.actions.confirm.show"
            [matDialogClose]="'confirmed'"
            class="flex items-center justify-center rounded-2xl px-6 h-11 text-[11px] font-black tracking-wider uppercase hover:shadow-lg transition-all shadow-md text-white"
            [ngClass]="{
                '!bg-amber-500 hover:!bg-amber-600': data.actions.confirm.color === 'accent',
                '!bg-emerald-600 hover:!bg-emerald-700': data.actions.confirm.color === 'success',
                '!bg-red-600 hover:!bg-red-700': data.actions.confirm.color === 'warn',
                '!bg-[#008BFF] hover:!bg-[#007be2]': data.actions.confirm.color === 'primary'
            }"
            [ngStyle]="isHexColor(data.actions.confirm.color) ? { 'background-color': data.actions.confirm.color } : null">
            {{ data.actions.confirm.label }}
        </button>
    </div>
</div>
